import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import api from 'services/api';
import {
  fetchBranchOffices,
  fetchUserCompaniesSelectOptions,
  fetchUserCostCentersByCompany,
} from 'utils/fetches';

import {
  Text,
  Select,
  Modal,
  Button,
  Toggle,
  DatePicker,
  Radio,
  Input,
} from 'v3/components';

import { DefaultLoadingComponent } from 'v3/components/List';

const DATE_OPTIONS = [
  {
    label: '1 dia',
    value: 1,
  },
  {
    label: '3 dias',
    value: 3,
  },
  {
    label: '7 dias',
    value: 7,
  },
  {
    label: '15 dias',
    value: 15,
  },
  {
    label: '30 dias',
    value: 30,
  },
  {
    label: '60 dias',
    value: 60,
  },
];

const MERCOSUL_DATE_OPTIONS = [
  {
    label: '1 dias',
    value: moment().add(1, 'days').startOf('day').toISOString(),
  },
  {
    label: '3 dias',
    value: moment().add(3, 'days').startOf('day').toISOString(),
  },
  {
    label: '7 dias',
    value: moment().add(7, 'days').startOf('day').toISOString(),
  },
  {
    label: '15 dias',
    value: moment().add(15, 'days').startOf('day').toISOString(),
  },
  {
    label: '30 dias',
    value: moment().add(30, 'days').startOf('day').toISOString(),
  },
  {
    label: '60 dias',
    value: moment().add(60, 'days').startOf('day').toISOString(),
  },
];

function Filter({
  isOpen,
  onClose,
  dashboard,
  name,
  values,
  id,
  setValues,
  mercosulDashboard = false,
  excludeFilterByDate = false,
  excludeFilterByNegotiator = false,
  excludeFilterByCompany = false,
  filterByCompanyMultiple = true,
  onlyCompanyFilter = false,
  excludeFilterByClients = false,
  excludeFilterByTags = false,
  excludeFilterByBranchOffice = false,
  excludeFilterByVehicleTypes = false,
  excludeFilterByVehicleBodies = false,
  excludeFilterByImplementTypes = false,
  filterByVehicleTypesMultiple = true,
  filterByVehicleBodiesMultiple = true,
  excludeFilterByImplementTypesMultiple = true,
  excludeFilterByRecuseCostCenters = true,
  excludeFilterDueDatePreLoads = false,
  excludeFilterByClientOrderNumber = false,
  excludeFilterByPreLoadStatus = false,
  excludeFilterByDestinationSector = true,
  excludeFilterByoriginSectors = true,
  excludeFilterTravelAdjustmentsStatus = true,
  excludeFilterTypeOccurrence = false,
  excludeFilterResponsibleGroup = false
}) {
  const [tags, setTags] = useState([]);
  const [clients, setClients] = useState([]);
  const [start_date, setStartDate] = useState();
  const [endDatePeriod, setEndDatePeriod] = useState();
  const [startDatePeriod, setStartDatePeriod] = useState();
  const [costCenters, setCostCenters] = useState([]);
  const [recuseCostCenters, setRecuseCostCenters] = useState([]);
  const [branches, setBranches] = useState([]);
  const [negotiators, setNegotiators] = useState([]);
  const [pcps, setPcps] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [filterByPeriod, setFilterByPeriod] = useState(false);
 const [errors, setErrors] = useState({});
  const [userCompaniesOptions, setUserCompaniesOptions] = useState([]);
  const [loadingFilters, setLoadingFilters] = useState(false);
  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [vehicleTypesOptions, setVehicleTypesOptions] = useState([]);
  const [vehicleBodies, setVehicleBodies] = useState([]);
  const [vehicleBodiesOptions, setVehicleBodiesOptions] = useState([]);
  const [implementTypes, setImplementTypes] = useState([]);
  const [implementTypesOptions, setImplementTypesOptions] = useState([]);
  const [dueDatePreLoads, setDueDatePreLoads] = useState()
  const [clientOrderNumber, setClientOrderNumber] = useState();
  const [preLoadStatusOptions, setPreLoadStatusOptions] = useState([]);
  const [preLoadStatus, setPreLoadStatus] = useState();
  const [travelAdjustmentsStatus, setTravelAdjustmentsStatus] = useState();
  const [destinationSector, setDestinationSector] = useState();
  const [originSector, setOriginSector] = useState();
  const [occurrenceTypeOptions, setOccurrenceTypeOptions] = useState([]);
  const [responsibleGroupOptions, setResponsibleGroupOptions] = useState([]);
  const [occurenceType, setOccurenceType] = useState();
  const [responsibleGroup, setResponsibleGroup] = useState();

  const destinationSectorsOptions = [
    { label: 'Cadastro', value: 'REGISTER' },
    { label: 'Emissão', value: 'EMISSION' },
    { label: 'GR', value: 'RISK_MANAGER' },
    { label: 'Negociador (Cliente)', value: 'NEGOTIATOR_CUSTOMER' },
    { label: 'Operação', value: 'OPERATION' },
  ]

  const originSectorsOptions = destinationSectorsOptions.filter(sector => sector.value !== 'OPERATION');

  const status = [
    { label: 'Pendente', value: 'PENDING' },
    { label: 'Finalizado', value: 'FINISHED' },
    { label: 'Anulado', value: 'ANNULLED' },
  ]

  async function onSearchTag(search) {
    try {
      const response = await api.get('tags', { params: { search } });
      return response.data.data;
    } catch (ex) {
      return [];
    }
  }

  async function onSearchNegotiator(search) {
    try {
      const response = await api.get('user/name', {
        params: { negotiator: search, isControlTower: true },
      });
      return response.data;
    } catch (error) {
      return [];
    }
  }

  async function onSearchUser(search) {
    try {
      const response = await api.get('user/name', {
        params: { search, isControlTower: true },
      });
      return response.data;
    } catch (error) {
      return [];
    }
  }

  async function onSearchClients(search) {
    try {
      const response = await api.get('persons/customers', {
        params: { search },
      });
      return response.data;
    } catch (ex) {
      return [];
    }
  }
  async function onSubmit() {

    if (filterByPeriod) {

      const startDate = moment(startDatePeriod, 'DD/MM/YYYY').format(
        'YYYY-MM-DD'
      );
      const endDate = moment(endDatePeriod, 'DD/MM/YYYY').format('YYYY-MM-DD');

      if (!isPeriodValid(startDate, endDate)) {
        return;
      }
    }

    try {
      const data = {
        tags: tags || [],
        clients: clients || [],
        negotiators: negotiators || [],
        costCenters: costCenters || [],
        recuseCostCenters: recuseCostCenters || [],
        branches: branches || [],
        pcps: pcps || [],
        companies: companies || [],
        vehicleTypes: vehicleTypes || [],
        vehicleBodies: vehicleBodies || [],
        implementTypes: implementTypes || [],
        sizes: values.sizes,
        component: name,
        start_date: filterByPeriod
          ? `${`${moment(startDatePeriod, 'DD/MM/YYYY').format('YYYY-MM-DD')}T00:00:00.000Z`}`
          : start_date,
        end_date: filterByPeriod
          ? `${`${moment(endDatePeriod, 'DD/MM/YYYY').format('YYYY-MM-DD')}T23:59:59.000Z`}`
          : undefined,
        card_id: id,
        filterByPeriod: filterByPeriod ? 1 : 0,
        dueDatePreLoads: dueDatePreLoads,
        clientOrderNumber: clientOrderNumber,
        preLoadStatus: preLoadStatus,
        destinationSector: destinationSector,
        originSector: originSector,
        travelAdjustmentsStatus: travelAdjustmentsStatus,
        occurenceType: occurenceType,
        responsibleGroup: responsibleGroup
      };

      setValues((old) => ({
        ...old,
        clients,
        negotiators,
        costCenters,
        recuseCostCenters,
        branches,
        pcps,
        companies,
        tags,
        vehicleTypes,
        vehicleBodies,
        implementTypes,
        travelAdjustmentsStatus,
        destinationSector,
        originSector,
        start_date: filterByPeriod
          ? `${`${moment(startDatePeriod, 'DD/MM/YYYY').format('YYYY-MM-DD')}T00:00:00.000Z`}`
          : start_date,
        end_date: filterByPeriod
          ? `${`${moment(endDatePeriod, 'DD/MM/YYYY').format('YYYY-MM-DD')}T23:59:59.000Z`}`
          : undefined,
        filterByPeriod,
        dueDatePreLoads,
        clientOrderNumber,
        preLoadStatus: preLoadStatus,
        occurenceType: occurenceType,
        responsibleGroup: responsibleGroup
      }));
      onClose();

      await api.put(`v3/dashboard/${dashboard.id}/parameters`, data);
    } catch (error) {
      //
    }
  }

  function isDateValid(start, end) {
    return !moment(start).isAfter(end);
  }

  function isPeriodValid(start, end) {
    return moment(end).diff(start, 'days') <= 30;
  }

  function handleEndDateChange(dateString) {
    setEndDatePeriod(dateString);
    const startDate = moment(startDatePeriod, 'DD/MM/YYYY').format('YYYY-MM-DD');
    const endDate = moment(dateString, 'DD/MM/YYYY').format('YYYY-MM-DD');
    dateString
      ? setErrors((prev) => ({
          ...prev,
          endDatePeriodError: !isDateValid(startDate, endDate)
            ? 'Data inicial não pode ser maior que data final'
            : !isPeriodValid(startDate, endDate)
            ? 'Período máximo de 30 dias!'
            : null,
        }))
      : setErrors((prev) => ({
          ...prev,
          endDatePeriodError: null,
        }));
  }

  async function getUserCompanies() {
    try {
      const response = await fetchUserCompaniesSelectOptions();
      setUserCompaniesOptions(response);
    } catch (error) {
    } finally {
      setLoadingFilters(false);
    }
  }

  async function getVehicleTypes() {
    try {
      const response = await api.get(`vehicle-types?app=${true}`);
      setVehicleTypesOptions(response.data);
    } catch (error) {
    } finally {
      setLoadingFilters(false);
    }
  }

  async function getVehicleBodies() {
    try {
      const response = await api.get('body-types');
      setVehicleBodiesOptions(response.data);
    } catch (error) {
    } finally {
      setLoadingFilters(false);
    }
  }

  async function getImplementTypes() {
    try {
      const response = await api.get(`vehicle-implement-types?app=${true}`)
      setImplementTypesOptions(response.data);
    } catch (error) {
    } finally {
      setLoadingFilters(false);
    }
  }

  async function onSearchGroups(search) {
    try {
      const response = await api.get('groups', {
        params: { search, onlyActive: false },
      });
      setResponsibleGroupOptions(response?.data);
    } catch (error) {
    } finally {
      setLoadingFilters(false);
    }
  }

  async function fetchOccurrencesTypesOptions() {
    try {
      const response = await cooperplaceApi.get('occurrences/types');
      setOccurrenceTypeOptions(response?.data?.message);
    } catch (error) {
    } finally {
      setLoadingFilters(false);
    }
  }


  useEffect(() => {
    if (isOpen) {
      setFilterByPeriod(values?.filterByPeriod);
      setStartDate(values?.start_date || DATE_OPTIONS[1].value);
      setStartDatePeriod(moment(values?.start_date).add(1, 'days').format('DD/MM/YYYY'));
      setEndDatePeriod(moment(values?.end_date).format('DD/MM/YYYY'));
      setTags(values?.tags || []);
      setClients(values?.clients || []);
      setNegotiators(values?.negotiators || []);
      setCostCenters(values?.costCenters || []);
      setRecuseCostCenters(values?.recuseCostCenters || []);
      setPcps(values?.pcps || []);
      setCompanies(values?.companies || []);
      setBranches(values?.branches || []);
      setVehicleTypes(values?.vehicleTypes || []);
      setVehicleBodies(values?.vehicleBodies || []);
      setImplementTypes(values?.implementTypes || []);
      setDueDatePreLoads(values?.dueDatePreLoads || 'SHOW');
      setClientOrderNumber(values?.clientOrderNumber || null);
      setPreLoadStatus(values?.preLoadStatus || 'ALL');
      setDestinationSector(values?.destinationSector || null);
      setOriginSector(values?.originSector || null);
      setTravelAdjustmentsStatus(values?.travelAdjustmentsStatus || null);
      setOccurenceType(values?.occurenceType || []);
      setResponsibleGroup(values?.responsibleGroup || []);
      if (excludeFilterByVehicleTypes === false) {
        setLoadingFilters(true);
        getVehicleTypes();
      }
      if (excludeFilterByVehicleBodies === false) {
        setLoadingFilters(true);
        getVehicleBodies();
      }
      if (excludeFilterByCompany === false) {
        setLoadingFilters(true);
        getUserCompanies();
      }

      if (excludeFilterByImplementTypes === false) {
        setLoadingFilters(true);
        getImplementTypes();
      }

      if (!excludeFilterByPreLoadStatus) {
        setPreLoadStatusOptions([
          { label: 'Todos', value: 'ALL' },
          { label: 'Atendidas', value: 'ATTENDED' },
          { label: 'Não atendidas', value: 'NOT_ATTENDED' },
          { label: 'Canceladas', value: 'CANCELLED' },
        ]);
      }

      if (!excludeFilterTypeOccurrence) {
        setLoadingFilters(true);
        fetchOccurrencesTypesOptions();
      }

      if (!excludeFilterResponsibleGroup) {
        setLoadingFilters(true);
        onSearchGroups();
      }
    }
  }, [isOpen]);

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        backdrop="static"
        heading={
          <Text color="dark" type="subheader" weight="bold">
            Filtros
          </Text>
        }
        body={
          loadingFilters ? (
            <DefaultLoadingComponent />
          ) : onlyCompanyFilter ? (
            <Row>
              <Col xs={12}>
                <Select
                  label="Empresa"
                  options={userCompaniesOptions}
                  value={companies}
                  onChange={(value) => setCompanies(value)}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  multiple={filterByCompanyMultiple}
                />
              </Col>
            </Row>
          ) : (
            <>
              <Row>
                {!excludeFilterByClients ? (
                  <Col xs={12} className="mb-3">
                    <Select.Async
                      label="Clientes"
                      value={clients}
                      onSearch={onSearchClients}
                      onChange={(value) => setClients(value)}
                      multiple
                      getOptionLabel={(option) => {
                        let label = `${option.social_name} - ${option.cgccpf}`;

                        if (option.city) {
                          label += ` - ${option.city}`;
                        }

                        return label;
                      }}
                      getOptionValue={(option) => option.id}
                    />
                  </Col>
                ) : null}

                {!excludeFilterByNegotiator ? (
                  <Col xs={12} className="mb-3">
                    <Select.Async
                      label="Negociador"
                      value={negotiators}
                      onSearch={onSearchNegotiator}
                      onChange={(value) => setNegotiators(value)}
                      multiple
                      getOptionLabel={(option) => {
                        let label = `${option.username}`;
                        if (option?.cpf) {
                          label += ` - ${option?.cpf}`;
                        }
                        return label;
                      }}
                      getOptionValue={(option) => option.id}
                    />
                  </Col>
                ) : null}
                {!excludeFilterByClientOrderNumber &&
                  <Col xs={6} md={6} className="mb-3">
                    <Input
                      label="Nº pedido do cliente"
                      value={clientOrderNumber ?? ""}
                      onChange={({ target: { value } }) => {
                        const numericValue = value.replace(/\D/g, "");

                        if (numericValue === "") {
                          setClientOrderNumber(null);
                        } else {
                          setClientOrderNumber(Number(numericValue));
                        }
                      }}
                    />
                  </Col>

                }

                <Col xs={6} className="mb-3">
                  <Select.Async
                    label="PCP"
                    value={pcps}
                    onSearch={onSearchUser}
                    onChange={(value) => setPcps(value)}
                    multiple
                    getOptionLabel={(option) => {
                      let label = `${option.username}`;
                      if (option?.cpf) {
                        label += ` - ${option?.cpf}`;
                      }
                      return label;
                    }}
                    getOptionValue={(option) => option.id}
                  />
                </Col>
                <Col xs={6} className="mb-3">
                  <Select.Async
                    label="Centro de Custo da Carga"
                    value={costCenters}
                    onSearch={fetchUserCostCentersByCompany}
                    onChange={(value) => setCostCenters(value)}
                    multiple
                    getOptionLabel={(option) => {
                      const label = `${option?.name}`;
                      return label;
                    }}
                    getOptionValue={(option) => option.id}
                  />
                </Col>

                {!excludeFilterByBranchOffice && (
                  <Col xs={6} className="mb-3">
                    <Select.Async
                      label="Filial"
                      value={branches}
                      onSearch={fetchBranchOffices}
                      onChange={(value) => setBranches(value)}
                      multiple
                      getOptionLabel={(option) => `${`${option.id} - ${option.name}`}`}
                      getOptionValue={(option) => option.id}
                    />
                  </Col>
                )}
                {!excludeFilterByTags && (
                  <Col md={6} xs={12} className="mb-3">
                    <Select.Async
                      removeInputMin
                      label="Tags"
                      value={tags}
                      onSearch={onSearchTag}
                      onChange={(value) => setTags(value)}
                      multiple
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                    />
                  </Col>
                )}
                {!excludeFilterByRecuseCostCenters && (
                  <Col xs={6} className="mb-3">
                    <Select.Async
                      label="Recusa de centro de custo"
                      value={recuseCostCenters}
                      onSearch={fetchUserCostCentersByCompany}
                      onChange={(value) => setRecuseCostCenters(value)}
                      multiple
                      getOptionLabel={(option) => {
                        const label = `${option?.name}`;
                        return label;
                      }}
                      getOptionValue={(option) => option.id}
                    />
                  </Col>
                )}
                {!excludeFilterByVehicleTypes && (
                  <Col md={6} xs={12} className="mb-3">
                    <Select
                      label="Tipo Veículo de Tração"
                      options={vehicleTypesOptions}
                      value={vehicleTypes}
                      onChange={(value) => setVehicleTypes(value)}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      multiple={filterByVehicleTypesMultiple}
                    />
                  </Col>
                )}
                {!excludeFilterByVehicleBodies && (
                  <Col md={6} xs={12} className="mb-3">
                    <Select
                      label="Tipos de carroceria"
                      options={vehicleBodiesOptions}
                      value={vehicleBodies}
                      onChange={(value) => setVehicleBodies(value)}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      multiple={filterByVehicleBodiesMultiple}
                    />
                  </Col>
                )}
                {!excludeFilterByImplementTypes && (
                  <Col md={6} xs={12} className="mb-3">
                    <Select
                      label="Tipo de implemento"
                      options={implementTypesOptions}
                      value={implementTypes}
                      onChange={value => setImplementTypes(value)}
                      getOptionLabel={option => option.name}
                      getOptionValue={option => option.id}
                      multiple={excludeFilterByImplementTypesMultiple}
                    />
                  </Col>
                )}
                {
                  !excludeFilterByoriginSectors && (
                    <Col xs={6} md={6}>
                      <Select
                        options={destinationSectorsOptions}
                        getOptionLabel={option => option.label}
                        getOptionValue={option => option.value}
                        label="Setor de destino"
                        onChange={value => setDestinationSector(value)}
                        value={destinationSector}
                      />
                    </Col>
                  )
                }
                {
                  !excludeFilterByDestinationSector && (
                    <Col xs={6} md={6}>
                      <Select
                        options={originSectorsOptions}
                        getOptionLabel={option => option.label}
                        getOptionValue={option => option.value}
                        label="Setor de origem"
                        onChange={value => setOriginSector(value)}
                        value={originSector}
                      />
                    </Col>

                  )
                }
                {
                  !excludeFilterTravelAdjustmentsStatus && (
                    <Col xs={6} md={6}>
                      <Select
                        options={status}
                        getOptionLabel={option => option.label}
                        getOptionValue={option => option.value}
                        label="Status"
                        onChange={value => setTravelAdjustmentsStatus(value)}
                        value={travelAdjustmentsStatus}
                      />
                    </Col>
                  )
                }
                {
                  !excludeFilterTypeOccurrence && (
                    <Col md={6} xs={6} className="mb-3">
                      <Select
                        multiple={true}
                        options={occurrenceTypeOptions}
                        getOptionLabel={option => option.name}
                        getOptionValue={option => option.id}
                        label="Tipo de ocorrência"
                        onChange={value => setOccurenceType(value)}
                        value={occurenceType}
                      />
                    </Col>
                  )
                }
                {
                  !excludeFilterResponsibleGroup && (
                    <Col md={6} xs={6} className="mb-3">
                      <Select
                        multiple={true}
                        options={responsibleGroupOptions}
                        getOptionLabel={option => option.name}
                        getOptionValue={option => option.id}
                        label="Grupo responsável"
                        onChange={value => setResponsibleGroup(value)}
                        value={responsibleGroup}
                      />
                    </Col>
                  )
                }
              </Row>
              <Row>
                {!excludeFilterByCompany && (
                  <Col xs={6}>
                    <Select
                      label="Empresa"
                      options={userCompaniesOptions}
                      value={companies}
                      onChange={(value) => setCompanies(value)}
                      getOptionLabel={(option) => option.name}
                      getOptionValue={(option) => option.id}
                      multiple={filterByCompanyMultiple}
                    />
                  </Col>
                )}
                {
                  !excludeFilterByPreLoadStatus && (
                    <Col md={6} xs={6} className="mb-3">
                      <Select
                        options={preLoadStatusOptions}
                        getOptionLabel={option => option.label}
                        getOptionValue={option => option.value}
                        label="Status"
                        onChange={value => setPreLoadStatus(value)}
                        value={preLoadStatus}
                      />
                    </Col>
                  )
                }
                <Row />
                {!excludeFilterDueDatePreLoads && (
                  <Col xs={12} md={6} className="mb-3">
                    <Radio.Group
                      label="Pré cargas vencidas"
                      horizontal
                      onChange={({ target: { value } }) =>
                        setDueDatePreLoads(value)
                      }
                      value={dueDatePreLoads}
                    >
                      <Radio value="SHOW">
                        <Text color="dark" type="label">
                          Exibir
                        </Text>
                      </Radio>
                      <Radio value="DONT_SHOW">
                        <Text color="dark" type="label">
                          Ocultar
                        </Text>
                      </Radio>
                    </Radio.Group>
                  </Col>
                )}
              </Row>
              {!excludeFilterByDate && (
                <>
                  <Row>
                    <Col xs={12} className="mb-3">
                      <Radio.Group
                        label="Filtrar por período específico"
                        onChange={() => {
                          setFilterByPeriod(!filterByPeriod);
                          setStartDate('');
                          setEndDatePeriod('');
                          setStartDatePeriod('');
                        }}
                        value={filterByPeriod}
                        horizontal
                      >
                        <Radio value>
                          <Text color="dark" type="label">
                            Sim
                          </Text>
                        </Radio>
                        <Radio value={false}>
                          <Text color="dark" type="label">
                            Não
                          </Text>
                        </Radio>
                      </Radio.Group>
                    </Col>
                  </Row>
                  {!filterByPeriod ? (
                    <Row>
                      <Col xs={12} className="mb-3">
                        <Toggle
                          label="Filtrar pelo período de"
                          labelColor="gray"
                          value={start_date}
                          defaultValue={start_date}
                          options={!mercosulDashboard ? DATE_OPTIONS : MERCOSUL_DATE_OPTIONS}
                          onSelected={(value) => {
                            setStartDate(value);
                          }}
                        />
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={6}>
                        <DatePicker
                          guide
                          label="Período de"
                          value={startDatePeriod}
                          format="DD/MM/YYYY"
                          onChange={({ target }) => {
                            setStartDatePeriod(target.value ? target.value : '');
                            setEndDatePeriod('');
                          }}
                          labelColor="gray"
                        />
                      </Col>
                      <Col xs={6}>
                        <DatePicker
                          disabled={!startDatePeriod}
                          guide
                          label="Até "
                          value={endDatePeriod}
                          format="DD/MM/YYYY"
                          onChange={({ target }) => {
                            handleEndDateChange(target?.value);
                          }}
                          labelColor="gray"
                          error={errors?.endDatePeriodError}
                        />
                      </Col>
                    </Row>
                  )}
                </>
              )}
            </>
          )
        }
        footer={
          <Button onClick={() => onSubmit()} className="py-2">
            <Text color="white" type="regular" weight="500">
              Filtrar
            </Text>
          </Button>
        }
      />
    </>
  );
}

export default Filter;
